import React from 'react';
import { BadgeCheckIcon, ClipboardCheckIcon, FileTextIcon, QuoteIcon, RulerIcon, StarIcon } from 'lucide-react';
import { FEATURED_TESTIMONIAL, QUALITY_PROMISES, TESTIMONIALS } from '../data/testimonials';
import { IMAGES } from '../data/site';
import { MAIN_WHATSAPP_MESSAGE } from '../data/messages';
import { WhatsAppButton } from './WhatsAppButton';
const PROMISE_ICONS = {
  medida: RulerIcon,
  revision: ClipboardCheckIcon,
  reposicion: BadgeCheckIcon,
  factura: FileTextIcon
} as const;
function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex gap-0.5 ${className}`} role="img" aria-label="5 de 5 estrellas" data-id="element-274" data-mp="1hyl4o7i2ipb6">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-accent-500 text-accent-500" aria-hidden="true" data-id="element-275" data-mp="183t54y4xdsdr" data-mpi={i} />)}
    </div>;
}
export function TestimonialsSection() {
  const f = FEATURED_TESTIMONIAL;
  return <section id="testimonios" className="scroll-mt-16 bg-white py-10 sm:py-16" data-id="element-276" data-mp="32frbmsbuoa5y">
      <div className="mx-auto max-w-content px-4 sm:px-6" data-id="element-277" data-mp="2v0svfb5xy84f">
        <div className="max-w-2xl" data-id="element-278" data-mp="2uz7zbh3zah4g">
          <h2 className="font-display text-[1.75rem] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-279" data-mp="2q39hydh2hzdj">
            Constructores del Bajío que ya encontraron el camino corto
          </h2>
          <p className="mt-2 text-sm text-steel-600 sm:text-base" data-id="element-280" data-mp="2zrre2heejiau">
            Lo que dicen quienes ya colaron su losa con material de OA LOSAS.
          </p>
        </div>

        {/* Testimonio principal + apoyo */}
        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-[minmax(0,1.35fr)_minmax(0,1fr)] lg:gap-6" data-id="element-281" data-mp="274oucvedxc4n">
          <figure className="grid min-w-0 grid-cols-1 overflow-hidden rounded-xl bg-navy-900 text-white sm:grid-cols-[minmax(0,1fr)_200px]" data-id="element-282" data-mp="2m1ny28648ktu">
            <div className="flex flex-col p-5 sm:p-8" data-id="element-283" data-mp="2h45w51qin5vc">
              <QuoteIcon className="h-8 w-8 text-accent-500" aria-hidden="true" data-id="element-284" data-mp="19cc1wmfoljg" />
              <blockquote className="mt-3 font-display text-xl font-medium leading-snug sm:text-2xl" data-id="element-285" data-mp="3shrjchctexe8">
                “{f.quote}”
              </blockquote>
              <figcaption className="mt-auto flex flex-wrap items-end justify-between gap-3 pt-6" data-id="element-286" data-mp="3h4wtxzt0nu4">
                <div data-id="element-287" data-mp="8fon2alfklsa">
                  <p className="font-semibold" data-id="element-288" data-mp="dd81pbm1j0kr">{f.name}</p>
                  <p className="text-sm text-steel-400" data-id="element-289" data-mp="ddq6wxqokp4t">
                    {f.role} · {f.city}
                  </p>
                </div>
                <div className="text-right" data-id="element-290" data-mp="3gtx3ylelbo4m">
                  <Stars className="justify-end" data-id="element-291" data-mp="3gv8bmwb5pg10" />
                  <p className="mt-1 text-xs text-steel-400" data-id="element-292" data-mp="3lsi5qp9hqfv6">{f.detail}</p>
                </div>
              </figcaption>
            </div>
            <img src={IMAGES.losaObra} alt="Losa armada con bovedilla EPS y malla de acero, lista para el colado" className="hidden h-full w-full object-cover object-center sm:block" loading="lazy" data-id="element-293" data-mp="3qr30wa9vy9cr" />
          </figure>

          <ul className="grid min-w-0 grid-cols-1 gap-3" data-id="element-294" data-mp="3318oftthamt1">
            {TESTIMONIALS.map(t => <li key={t.id} className="rounded-xl bg-steel-50 p-4 sm:p-5" data-id="element-295" data-mp="1k64ggrois3ec">
                <figure data-id="element-296" data-mp="1g512kaq18hfr">
                  <Stars data-id="element-297" data-mp="1g6vnvq57ubkd" />
                  <blockquote className="mt-2 text-[15px] leading-relaxed text-navy-900" data-id="element-298" data-mp="1g3g5oeg8wmeq">“{t.quote}”</blockquote>
                  <figcaption className="mt-3 flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1 text-sm" data-id="element-299" data-mp="1b8an9pm1xpve">
                    <span data-id="element-300" data-mp="1181mdyh47g9o">
                      <span className="font-semibold text-navy-900" data-id="element-301" data-mp="119blmqzpeuhw">{t.name}</span>
                      <span className="text-steel-600" data-id="element-302" data-mp="wh1oapw9es5l"> · {t.role}, {t.city}</span>
                    </span>
                    <span className="text-xs text-steel-600" data-id="element-303" data-mp="sf6rnyp9x2y5">{t.detail}</span>
                  </figcaption>
                </figure>
              </li>)}
          </ul>
        </div>

        {/* Compromisos de calidad */}
        <div className="mt-10 border-t border-steel-200 pt-8" data-id="element-304" data-mp="ihac8upazlu8">
          <h3 className="font-display text-2xl font-bold text-navy-900 sm:text-3xl" data-id="element-305" data-mp="difodechb739">
            Nuestro compromiso de calidad
          </h3>
          <ul className="mt-5 grid grid-cols-1 gap-x-8 gap-y-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-306" data-mp="2dlqj5y68fah4">
            {QUALITY_PROMISES.map(p => {
            const Icon = PROMISE_ICONS[p.id as keyof typeof PROMISE_ICONS];
            return <li key={p.id} className="flex gap-3 lg:flex-col lg:gap-2" data-id="element-307" data-mp="28tqextj4pveq">
                  <Icon className="mt-0.5 h-6 w-6 shrink-0 text-signal-600" aria-hidden="true" data-id="element-308" data-mp="28rvwclvbyfdt" />
                  <div data-id="element-309" data-mp="1uwtpnwinslzy">
                    <p className="font-semibold text-navy-900" data-id="element-310" data-mp="1zu3cr5ikslkm">{p.title}</p>
                    <p className="mt-0.5 text-sm leading-relaxed text-steel-600" data-id="element-311" data-mp="1kwayegorm380">{p.text}</p>
                  </div>
                </li>;
          })}
          </ul>

          <div className="mt-8 flex flex-col gap-3 rounded-xl bg-steel-50 p-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-312" data-mp="1pxgsoiy2pyjn">
            <p className="text-[15px] font-medium text-navy-900" data-id="element-313" data-mp="3k9f5euvldcka">
              ¿Quieres ser el siguiente? Te cotizamos hoy y la entrega va sin costo desde $5,000.
            </p>
            <WhatsAppButton message={MAIN_WHATSAPP_MESSAGE} label="Cotizar por WhatsApp" location="testimonios" size="lg" className="shrink-0" data-id="element-314" data-mp="18jpd9dwohs7m" />
          </div>
        </div>
      </div>
    </section>;
}